import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import routerHistory from '../../routerHistory';
import * as accountActions from '../../actions/accountActions';
import { ROUTES } from '../../const';
import { smartLoaderService } from '../../services/domain/smartLoaderService';
import { redirect } from '../../utils/HttpUtils';
import RegisterSSOCodeSelection from './RegisterSSOCodeSelection';

class RegisterAzureCodeSelection extends React.Component {
  componentDidMount() {
    const { accountActions, user } = this.props;

    if (!user.email) {
      routerHistory.push(ROUTES.HOME);
    }

    accountActions.setIndexTransition(true);
  }

  onSubmit = user => {
    const { redirectAfterLogin, accountActions, avatars } = this.props;

    user.picture = (avatars && typeof avatars === 'object' && Object.values(avatars).length > 0
      ? Object.values(avatars).indexOf(user.picture)
      : user.picture || 1
    ).toString();

    smartLoaderService.open();
    accountActions
      .signUpWithAzure(user)
      .then(() => {
        redirect(window.location.origin + redirectAfterLogin).then(() => {
          accountActions.clearRedirectAfterLogin();
          smartLoaderService.close();
        });
      })
      .catch(() => {
        smartLoaderService.close();
      });
  };

  render() {
    const { user } = this.props;

    return <RegisterSSOCodeSelection user={user} onSubmit={this.onSubmit} title={I18n.t('register.azureTitle')} />;
  }
}

function mapStateToProps(state) {
  return {
    signUp: state.signUp,
    user: state.account.user,
    i18n: state.i18n,
    redirectAfterLogin: state.router.redirectAfterLogin,
    avatars: state.theme.images.avatars
  };
}

function mapDispatchToProps(dispatch) {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RegisterAzureCodeSelection);
